<div class='projects' style='height: 100%'>
  <div style="display: flex; flex-direction: row; justify-content: end; align-items: start">
    <div style="display: flex; flex-direction: row;">
      <div class="menu">
        <button mat-raised-button [matMenuTriggerFor]="appMenu"
                style="border-radius: 6px;margin-right: 10px;white-space: nowrap; "
                class="button">
          Actions<span class="mat-select-arrow"
                       style="display:inline-block; width: 0;height: 0;border-left: 5px solid transparent;border-right: 5px solid transparent;border-top: 5px solid;margin: 0 4px;"></span>
        </button>
        <mat-menu #appMenu="matMenu">
          <button mat-menu-item
                  [routerLink]="['/projects/project/create']"
                  style="border-radius: 6px;margin-right: 10px;"
                  *ngIf="canCreateProject">
            Create Project
          </button>
          <button mat-menu-item
                  [routerLink]="['/projects/clone']"
                  style="border-radius: 6px;margin-right: 10px;"
                  *ngIf="canCreateProject"
                  [disabled]="!canClone">
            Clone Project
          </button>
          <button mat-menu-item
                  [routerLink]="['/fleets']"
                  style="border-radius: 6px;margin-right: 10px;"
                  *ngIf="isAutonomyEnabled">
            Manage Fleets
          </button>
          <button mat-menu-item
                  style="border-radius: 6px;margin-right: 10px;"
                  *ngIf="canCreateProject" (click)="openImportSsp()">
            Import SSP
          </button>
          <button mat-menu-item
                  style="border-radius: 6px;margin-right: 10px;"
                  *ngIf="canCreateProject" (click)="openImportOscal()">
            Import OSCAL
          </button>
        </mat-menu>
      </div>
    </div>
  </div>
  <div class='table-responsive'>
    <div>
      <p-table [value]="projects"
               [rows]="100"
               [paginator]="true"
               [pageLinks]="3"
               [rowsPerPageOptions]="[10, 20, 50, 100]"
               [style]="{'margin-top':'10px'}"
               selectionMode="single"
               #table
               rowGroupMode="subheader"
               expandableRowGroups="true"
               [groupRowsBy]="isAutonomyEnabled ? 'fleetName' : undefined"
               [sortField]="'fleetName'"
               (onRowSelect)="openProject($event.data.projectId)">

        <ng-template pTemplate="groupheader" let-item>
          <span *ngIf="isAutonomyEnabled" class="font-bold">
            @if (item.fleetId) {
            <a [routerLink]="['/fleet-home', item.fleetId]">{{ item.fleetName }}</a>
            }
            @else {
              {{ item.fleetName }}
            }

          </span>
        </ng-template>

        <ng-template pTemplate="header">
          <tr [ngStyle]="{'white-space': 'nowrap'}">
            <th *ngFor="let col of cols" [pSortableColumn]="col.field">
              {{col.header}}
              <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                          ariaLabelDesc="Activate to sort in descending order"
                          ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-item>
          <tr [pSelectableRow]="item">
            <td>{{item.name}}</td>
            <td style="width:9em">{{item.status}} %</td>
            <td>{{item.dueDate | date:'yyyy-MM-dd'}}</td>
            <td>{{item.itemsRemaining}}/{{item.itemsCount}}</td>
          </tr>
        </ng-template>
      </p-table>

    </div>
  </div>
</div>
